import React from 'react';
import { Formik } from 'formik';
import { useToast } from '@chakra-ui/react';
import Photos from './Photos';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useCreatePhoto } from '../../../services/api/generated/client';
import { templateReplace, localise } from '../../../services/lang/lang';
import { capitalise } from '../../../services/text/format';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { storeLocalFile } from '../../../services/photos/localImageUrlCache';
const PhotosWrapper = ({ onPhotosMutated, model, type, isShare = false, ...rest }) => {
    const toast = useToast();
    const initialValues = {
        media: undefined,
    };
    const capitalised = capitalise(type);
    const documentableType = `App\\Models\\${capitalised}`;
    const createPhoto = useGenericMutationUseCase(useCreatePhoto);
    const handleAddPhoto = (values, helpers) => {
        createPhoto.execute({
            data: {
                documentable_type: documentableType,
                documentable_id: model.id,
                file: values.media,
            },
        }, helpers, {
            onSuccess: (response) => {
                const photo = unwrapModel(response);
                if (values.media && photo)
                    storeLocalFile(photo.id, values.media);
                helpers.resetForm();
                toast({
                    title: templateReplace(localise('PHOTO_UPLOADED'), {
                        noun: capitalised,
                    }),
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                });
                onPhotosMutated?.();
            },
        });
    };
    return (React.createElement(Formik, { initialValues: initialValues, onSubmit: handleAddPhoto },
        React.createElement(Photos, { isShare: isShare, onPhotosMutated: onPhotosMutated, ...rest })));
};
export default PhotosWrapper;
